import { api, plainAxios } from "./http";
import { asForm, asJson } from "./headers";

export const loginPassword = ({ username, password, deviceHeaders }) => {
  const body = new URLSearchParams({
    grant_type: "password",
    username,
    password,
    client_id: "my-frontend",
    scope: "offline_access",
  });

  return plainAxios.post("/connect/token", body, {
    headers: deviceHeaders,
  });
};

export const apiLoginGoogle = ({
  code,
  code_verifier,
  redirect_uri,
  deviceHeaders,
}) => {
  const body = new URLSearchParams({
    grant_type: "google",
    code,
    code_verifier,
    redirect_uri,
    client_id: "my-frontend",
    scope: "offline_access",
  });

  return plainAxios.post("/connect/token", body, {
    headers: deviceHeaders,
  });
};

export const login2FA = ({ code, deviceHeaders }) => {
  const body = new URLSearchParams({
    grant_type: "2fa_verification",
    password: code,
    client_id: "my-frontend",
    scope: "offline_access",
  });

  return api.post("/connect/token", body, { headers: deviceHeaders });
};

export const selectOrganization = ({ orgId, deviceHeaders }) => {
  const body = new URLSearchParams({
    grant_type: "select_organization",
    x_organization_id: orgId,
    client_id: "my-frontend",
    scope: "offline_access",
  });

  return api.post("/connect/token", body, { headers: deviceHeaders });
};

export const apiSwitchOrganization = ({
  orgId,
  accessToken,
  deviceHeaders,
}) => {
  const body = new URLSearchParams({
    grant_type: "switch_organization",
    x_organization_id: orgId,
    client_id: "my-frontend",
    scope: "offline_access",
  });

  return plainAxios.post("/connect/token", body, {
    headers: {
      ...(deviceHeaders || {}),
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const apiImpersonateWithPin = ({
  targetUserId,
  pin,
  accessToken,
  deviceHeaders,
}) => {
  const body = new URLSearchParams({
    grant_type: "impersonation_pin",
    target_user_id: targetUserId,
    pin,
    client_id: "my-frontend",
    scope: "offline_access",
  });

  return plainAxios.post("/connect/token", body, {
    headers: {
      ...(deviceHeaders || {}),
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const refreshAccessToken = () => {
  const refresh_token = localStorage.getItem("refresh_token");
  if (!refresh_token) throw new Error("No refresh token");

  const body = new URLSearchParams({
    grant_type: "refresh_token",
    refresh_token,
    client_id: "my-frontend",
    scope: "offline_access",
  });

  return plainAxios.post("/connect/token", body, asForm());
};

export const revokeToken = async (token, tokenTypeHint) => {
  const clientId = "my-frontend";

  const body = new URLSearchParams({
    client_id: clientId,
    token,
    token_type_hint: tokenTypeHint,
  });

  return plainAxios.post("/connect/revoke", body);
};

export const bridgeSso = async () => {
  return api.post("/sso/bridge", null, { withCredentials: true });
};

export const getSsoConsentInteraction = async (interaction) => {
  return api.get("/connect/authorize/interaction", {
    params: { interaction },
  });
};

export const submitSsoConsentDecision = async (interaction, decision) => {
  return api.post(
    "/connect/authorize/interaction/decision",
    { interaction, decision },
    asJson(),
  );
};

export const logoutSession = async (token) => {
  return plainAxios.post("/session/logout", { token }, {
    ...asJson(),
    idempotent: true,
    timeout: 5000,
    withCredentials: true,
  });
};
